import { useTutorial } from './TutorialProvider';

export default useTutorial;
